import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { AlertCircleIcon } from '@contra/icons/icons';
import { useTheme } from 'styled-components';

type PrimarySkillChangedWarningModalProps = CommonTemplateProps & {
  readonly description: string;
  readonly handleCheckboxCTAClick: () => void;
  readonly handlePrimaryCTAClick: () => void;
  readonly onClose: () => void;
  readonly title: string;
};

export const PrimarySkillChangedWarningModal = ({
  description,
  handleCheckboxCTAClick,
  handlePrimaryCTAClick,
  isOpen,
  onClose,
  title,
}: PrimarySkillChangedWarningModalProps) => {
  const theme = useTheme();
  return (
    <ModalTemplateWrapper
      ariaLabel={title}
      ctaOptions={{
        checkboxCTA: {
          default: false,
          handleOnClick: handleCheckboxCTAClick,
          label: 'Don’t show again',
        },
        primaryCTA: {
          handleOnClick: handlePrimaryCTAClick,
          label: 'Sounds Good',
        },
        secondaryCTA: {
          handleOnClick: onClose,
          label: 'Cancel',
        },
      }}
      desktopModalSize="md"
      headerText={title}
      icon={
        <AlertCircleIcon
          color={theme.colorsV2.yellow50}
          size={24}
        />
      }
      isOpen={isOpen}
      onClose={onClose}
      subheaderText={description}
    />
  );
};
